import quoteSuccessLogoUrl from "../Assets/images/cms-logo-new.png";

/** Thank-you / order-success logo (higher-res PNG for sharp display at 128px). */
export const QUOTE_SUCCESS_LOGO_URL: string = quoteSuccessLogoUrl;

let preloaded = false;

/** Warm browser cache when user enters manual/bulk quote flow (before submit). */
export function preloadQuoteSuccessLogo(): void {
  if (preloaded || typeof window === "undefined") return;
  preloaded = true;
  const img = new Image();
  img.decoding = "async";
  img.src = QUOTE_SUCCESS_LOGO_URL;
}
